import { defineComponent as _defineComponent } from 'vue';
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BLink } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { updateWorkflow } from "@/components/Workflow/workflows.services";
import { useUserStore } from "@/stores/userStore";
import TextSummary from "@/components/Common/TextSummary.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import WorkflowActions from "@/components/Workflow/List/WorkflowActions.vue";
import WorkflowActionsExtend from "@/components/Workflow/List/WorkflowActionsExtend.vue";
import WorkflowIndicators from "@/components/Workflow/List/WorkflowIndicators.vue";
import WorkflowInvocationsCount from "@/components/Workflow/WorkflowInvocationsCount.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowCard',
    props: {
        workflow: null,
        gridView: { type: Boolean, default: false },
        hideRuns: { type: Boolean, default: false },
        filterable: { type: Boolean, default: true },
        publishedView: { type: Boolean, default: false },
        editorView: { type: Boolean, default: false },
        current: { type: Boolean, default: false }
    },
    emits: ["tagClick", "refreshList", "updateFilter", "rename", "preview", "insert", "insertSteps"],
    setup(__props, { emit }) {
        const props = __props;
        const userStore = useUserStore();
        const { isAnonymous } = storeToRefs(userStore);
        const workflow = computed(() => props.workflow);
        const shared = computed(() => {
            return !userStore.matchesCurrentUsername(workflow.value.owner);
        });
        const description = computed(() => {
            if (workflow.value.annotations && workflow.value.annotations.length > 0) {
                return workflow.value.annotations[0].trim();
            }
            else {
                return null;
            }
        });
        async function onTagsUpdate(tags) {
            workflow.value.tags = tags;
            await updateWorkflow(workflow.value.id, { tags });
            emit("refreshList", true, true);
        }
        async function onTagClick(tag) {
            emit("tagClick", tag);
        }
        const dropdownOpen = ref(false);
        return { __sfc: true, props, emit, userStore, isAnonymous, workflow, shared, description, onTagsUpdate, onTagClick, dropdownOpen, faPen, FontAwesomeIcon, BButton, BLink, TextSummary, StatelessTags, WorkflowActions, WorkflowActionsExtend, WorkflowIndicators, WorkflowInvocationsCount };
    }
});
